/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {memo, MouseEventHandler} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {dlsTypography} from '../theme/theme';
import {CellMenuItem} from './CellMenuItem';

export interface HeaderButtonProps {
  icon?: JSX.Element;
  label: string;
  disabled?: boolean;
  onClick?: MouseEventHandler;
  showDisabledBulkTooltip?: boolean;
  menuPaddingTop?: string;
}

const useStyles = makeStyles(() => ({
  selectionsLabel : {
    ...dlsTypography('selectionsLabel')
  }
}));

/**
 * Re-usable button for a grid header.
 *
 * ```typescript
 *
 *   import {HeaderButton} from '@ion/dls/src/grid/';
 *
 *   <HeaderButton onClick={onClick}
 *    icon={<MaterialMoreVertIcon />}
 *    label={translate(...)} />
 *
 * ```
 */
export const HeaderButton = ({
  onClick,
  icon,
  label,
  menuPaddingTop,
  disabled = false,
  showDisabledBulkTooltip = false
}: HeaderButtonProps) => {
  const classes = useStyles({showDisabledBulkTooltip});
  return (
    <CellMenuItem customStyles={{root: classes.selectionsLabel}}
      showDisabledBulkTooltip={showDisabledBulkTooltip}
      paddingTop={menuPaddingTop}
      onClick={onClick}
      disabled={disabled}
      icon={icon}
      label={label} />
  );
};

export default memo(HeaderButton);
